import antdSA from 'antd/lib/locale-provider/ca_ES';
import * as appLocaleData from 'react-intl/locale-data/es';
import saMessages from '../locales/es_ES';

const saLang = {
    messages: {
        ...saMessages
    },
    antd: antdSA,
    locale: 'es',
    data: appLocaleData
};
export default saLang;



// WEBPACK FOOTER //
// ./src/languageProvider/entries/es_ES.ts